import "./Footer.css";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";

import {
  XyncelyWhite,
  Twitter,
  LinkedIn,
  Instagram,
  Facebook,
  Whatsapp,
} from "../IconsImport";

const Footer = () => {

  const navigate = useNavigate();
  
   const handleLogoClick = () => {
    navigate("/");
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <footer className="footer">
      <div className="footer__container">

        {/* Top */}
        <div className="footer__top">

          {/* Brand */}
          <div className="footer__brand">
           <RouterLink
                      to="/"
                      className="footer__logo"
                      onClick={handleLogoClick}
                    >
                      <img
                        src={XyncelyWhite}
                        alt="Xyncely"
                      />
                    </RouterLink>

            <p>
              Campaign intelligence and operational
              <br />
              command center for modern marketing
              <br />
              teams.
            </p>
          </div>

          {/* Links */}
          <div className="footer__links">

            <div className="footer__column">
              <h3>Company</h3>

              <Link to="/about">About</Link>
              <Link to="/careers">Careers</Link>
            </div>

            <div className="footer__column">
              <h3>Resources</h3>

              <Link to="/privacy">Privacy Policy</Link>
              <Link to="/terms">Terms of Service</Link>
              <Link to="/contact">Contact Us</Link>
            </div>

          </div>
        </div>

        {/* Divider */}
        <div className="footer__divider"></div>

        {/* Bottom */}
        <div className="footer__bottom">

          <p className="footer__copyright">
            © 2026 Xyncely, Inc. All rights reserved.
          </p>

          {/* Social Icons */}
          <div className="footer__socials">

            <a
              href="https://x.com/xyncelyhq"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Twitter"
            >
              <img src={Twitter} alt="Twitter" />
            </a>

            <a
              href="https://www.linkedin.com/company/xyncely/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
            >
              <img src={LinkedIn} alt="LinkedIn" />
            </a>

            <a
              href="https://www.instagram.com/xyncelyhq/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <img src={Instagram} alt="Instagram" />
            </a>

            <a
              href="https://www.facebook.com/xyncelyhq/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
            >
              <img src={Facebook} alt="Facebook" />
            </a>

            <a
              href="https://www.whatsapp.com/channel/0029VaDbU2905MUjde3rFk15"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="WhatsApp"
            >
              <img src={Whatsapp} alt="Whatsapp" />
            </a>

          </div>

        </div>

      </div>
    </footer>
  );
};

export default Footer;